/**
 * @generated SignedSource<<3a72e00d7301b540f84fd4a45840a52b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CaregiverAbsenceReason = "OTHER" | "VACATION" | "SICK" | "%future added value";
export type UpdateCaregiverAbsenceInput = {
  id: string;
  from: string;
  to: string;
  reason: CaregiverAbsenceReason;
  clientMutationId?: string | null;
};
export type EditAbsenceFormMutation$variables = {
  input: UpdateCaregiverAbsenceInput;
};
export type EditAbsenceFormMutation$data = {
  readonly updateCaregiverAbsence: {
    readonly absence: {
      readonly id: string;
      readonly from: string;
      readonly to: string;
      readonly reason: string;
    } | null;
  } | null;
};
export type EditAbsenceFormMutation = {
  variables: EditAbsenceFormMutation$variables;
  response: EditAbsenceFormMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCaregiverAbsencePayload",
    "kind": "LinkedField",
    "name": "updateCaregiverAbsence",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Absence",
        "kind": "LinkedField",
        "name": "absence",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "from",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "to",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reason",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditAbsenceFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditAbsenceFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3268eeba3adabbe2f16a92a267739aa1",
    "id": null,
    "metadata": {},
    "name": "EditAbsenceFormMutation",
    "operationKind": "mutation",
    "text": "mutation EditAbsenceFormMutation(\n  $input: UpdateCaregiverAbsenceInput!\n) {\n  updateCaregiverAbsence(input: $input) {\n    absence {\n      id\n      from\n      to\n      reason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd4714db82025e7fc196b4f0f586dc9c";

export default node;
